import { Link } from "react-router-dom";

function Schooltiming() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">  About</li>
          <li className="breadcrumb-item active"> School Timings</li>
        </ul>
      </div>
      <div className="innersec container my-5 founder_message">
        <div className="row">
          <div class="col-lg-12">
            <h1> School Timings </h1>
          </div>

          <table>
            <tr>
              <th colspan="2">Monday to Friday: </th>
            </tr>
            <tr>
              <td>Assembly</td>
              <td>08:00 a.m. to 08:10 a.m.</td>
            </tr>
            <tr>
              <td>Pre-Nursery / LKG / UKG</td>
              <td>07:55 a.m. to 12:00 noon</td>
            </tr>
            <tr>
              <td>Class I to II</td>
              <td>07:55 a.m. to 12:30 p.m.</td>
            </tr>
            <tr>
              <td>Class III to V</td>
              <td>07:55 a.m. to 01:30 p.m.</td>
            </tr>
            <tr>
              <td>Class VI to X</td>
              <td>07:55 a.m. to 01:45 p.m.</td>
            </tr>
          </table>
          <p class="note">
            The school will not be responsible for any student before and after the above working hours.
          </p>
          <table>
            <tr>
              <th colspan="2">SCHOOL OFFICE HOURS</th>
            </tr>
            <tr>
              <td>Monday to Friday</td>
              <td>08.00 a.m. to 04.00 p.m.</td>
            </tr>
            <tr>
              <td>Saturday</td>
              <td>08.30 a.m. to 12.30 p.m.</td>
            </tr>
          </table>
          <p class="note">(Except on holidays and closed days)</p>
        </div>
      </div>
    </>
  );
}
export default Schooltiming;
